import { useRouter } from "next/navigation";
import Button from "@portal/components/atoms/v2/buttons/button";
import { IFooterProps } from "./types";

export const RobotFooterComponent = ({
  pageIndex,
  centerId,
  primaryButtonText,
  secondaryButtonText,
  disabled = false,
  onNextClick,
}: IFooterProps) => {
  const router = useRouter();

  function OnFooterClick(pageIndex: number, centerId: string, primary?: boolean) {
    if (primary) {
      if (onNextClick) onNextClick();
      router.push(`/robot/${++pageIndex}?centerId=${centerId}`);
    } else router.push(`/robot/${--pageIndex}?centerId=${centerId}`);
  }

  return (
    <div className="flex w-full py-5 px-3 md:px-5 justify-between">
      <Button onClick={() => OnFooterClick(Number(pageIndex), centerId)} text={secondaryButtonText} />
      <Button
        onClick={() => OnFooterClick(Number(pageIndex), centerId, true)}
        text={primaryButtonText}
        disabled={disabled}
        primary
      />
    </div>
  );
};
